// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    QUEER50_PAGE_LOADING() {
      return {
        isLoading: true,
        queer50: action.queer50
      };
    },
    QUEER50_PAGE_LOADED() {
      const currentState = store.getState();
      const queer50Data = get(currentState, 'queer50.data');
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        queer50Data,
        'queer50Page'
      );

      return {
        isLoading: false,
        data: action.queer50,
        ads: adModelData
      };
    },
    QUEER50_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.queer50.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
